export default __webpack_public_path__ + "static/media/metamask_steps_4.d8ca8d1d.png";